    import angular from "angular";

angular
    .module('app')
    .component('importEmployees', {
        template: require('./import-employees.html'),
        controller: ['$http', 'Upload', 'notifier', '$scope', 'moment', controller],
        bindings: {
            client: '<',
            fields: '<',
        }
    });

function controller($http, Upload, notifier, $scope, moment) {

    const $ctrl = this;

    $ctrl.file = null;

    $ctrl.loading = false;

    $ctrl.items = null;

    $ctrl.confirmLoading = false;

    $ctrl.completed = false;

    $ctrl.uploadFile = () => {
        $ctrl.loading = true;

        Upload.upload({
            url: `/clients/${$ctrl.client.id}/employees/parse-excel`,
            data: {file: $ctrl.file}
        }).then(
            res => {
                $ctrl.loading = false;
                $ctrl.items = res.data;
            },
            err => {
                $ctrl.loading = false;
                notifier.errorResponseNotify(err);
            }
        );
    };

    $ctrl.confirm = async function () {
        $ctrl.confirmLoading = true;

        for (let i = 0; i < $ctrl.items.length; i++) {
            const emp = $ctrl.items[i];

            if (emp.status !== 'success') {
                continue;
            }

            const params = {
                first_name: emp.firstName,
                last_name: emp.lastName,
                patronymic: emp.patronymic,
                iin: emp.iin,
                birth_date: moment(emp.birth_date, 'DD.MM.YYYY').format('YYYY-MM-DD'),
                gender: emp.gender,
                citizenship_code: emp.citizenship_code,
            };

            try {
                if (emp.id) {
                    await $http.post(`/employees/${emp.id}`, params);
                } else {
                    await $http.post(`/clients/${$ctrl.client.id}/employees`, params);
                }

                emp.resultStatus = 'success';
            } catch (err) {
                emp.resultStatus = 'error';
                emp.resultErrorMessage = err.data.message;
            }
        }

        $ctrl.completed = true;

        $scope.$apply();
    };
}


// WEBPACK FOOTER //
// ./resources/assets/modules/components/import-employees/import-employees.js